import { render, staticRenderFns } from "./vehicle_gear_data.vue?vue&type=template&id=6310464a&scoped=true"
import script from "./vehicle_gear_data.vue?vue&type=script&lang=js"
export * from "./vehicle_gear_data.vue?vue&type=script&lang=js"
import style0 from "./vehicle_gear_data.vue?vue&type=style&index=0&id=6310464a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310464a",
  null
  
)

export default component.exports